import React from 'react';
import { withStyles } from '@material-ui/styles';

import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';

import classes from './BobKpiPanel.module.css';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'white',
        color:           'black',
        fontSize:        theme.typography.pxToRem(12),
        border:          '1px solid grey',
        borderRadius:    '5px'
    }
}))(Tooltip);

const BobKpiPanel = ({
    title,
    rows,
    information,
    ...props
}) => {

    return (
        <Paper className={classes.KpiPanel}>
            <div className={classes.Title}>
                {title}
                <div className={classes.Icon}>
                    <HtmlTooltip
                        title={
                            <span className={classes.Tooltip}>
                                {information}
                            </span>
                        }
                        placement="top-start"
                    >
                        <span><i className="fas fa-info-circle" /></span>
                    </HtmlTooltip>
                </div>
            </div>
            <div className={classes.ItemContainer}>
                {rows.map((item, index) =>
                    <div key={index} className={classes.ItemRow}>
                        <span className={classes.Label}>
                            {item.label}
                        </span>
                        <span className={classes.Value}>
                            {item.value}
                            {
                                index !== 0 ?
                                    parseFloat(item.value) > 0 ?
                                        <img className={classes.Icon} src="/assets/images/red_arrow_up.svg" alt="" />
                                        :
                                        parseFloat(item.value) < 0 ?
                                            <img className={classes.Icon} src="/assets/images/green_arrow_down.svg" alt="" />
                                            :
                                            null
                                    :
                                    null
                            }
                        </span>
                    </div>
                )}
            </div>
        </Paper>
    );
};

export default BobKpiPanel;
